import { createContext, useContext } from "react";

export type CompensationChange = {
  effectiveDate?: string;
  pay: string;
  jobTitle: string;
  roleResponsibilities: string;
  previous_pay?: number;
  previous_jobTitle?: string;
  previous_roleResponsibilities?: string;
};

type CompensationChangeContextType = {
  currentStep: 1 | 2;
  values: Partial<CompensationChange>;
  setValues: (values: Partial<CompensationChange>) => void;
  onNext: () => void;
  onCancel: () => void;
  onBack: () => void;
};

export const CompensationChangeContext = createContext<
  CompensationChangeContextType | undefined
>(undefined);

export function useCompensationChange() {
  const value = useContext(CompensationChangeContext);

  if (!value) throw new Error("Context value should never be undefined");

  return value;
}
